import axios from "axios";

let companyUserSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const companyUserAxiosInstance = axios.create({
	baseURL: companyUserSvc
});

export default {
	userService: {
		getUserData(url, token) {
			return companyUserAxiosInstance.get(url, {
				headers: {
					Authorization: "Bearer " + btoa(token),
					"Content-Type": "application/x-www-form-urlencoded"
				}
			});
		},
		confirmUserData(url, userData, token) {
			// axios.defaults.headers.common["Authorization"] = "Basic " + btoa(token);
			return companyUserAxiosInstance.put(url, userData, {
				headers: {
					Authorization: "Bearer " + btoa(token),
					"Content-Type": "application/json"
				}
			});
		},
		getMessages(formData, token) {
			return companyUserAxiosInstance.get(
				companyRoot + "/v2/app_messages" + formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json"
					}
				}
			);
		},
		markMessageAsRead(message, token) {
			return companyUserAxiosInstance.put(
				companyRoot + "/v2/app_messages/" + message.id,
				message,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json"
					}
				}
			);
		},
		getAddressPoints(companyId, params, token) {
			return companyUserAxiosInstance.get(
				companyRoot +
				"/v1/user_companies/" +
				companyId +
				"/delivery_points/search" +
				params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json"
					}
				}
			);
		},
		changeAddressPoint(companyId, deliveryPoint, token) {
			return companyUserAxiosInstance.put(
				companyRoot +
				"/v1/user_companies/" +
				companyId +
				"/delivery_points/" +
				deliveryPoint.codcom,
				deliveryPoint,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json"
					}
				}
			);
		},
		logActivity( userid, activity, token) {
			// axios.defaults.headers.common["Authorization"] = "Basic " + btoa(token);
			return companyUserAxiosInstance.post(companyRoot +
				"/v1/users/" +
				userid +
				"/activity", activity, {
				headers: {
					Authorization: "Bearer " + btoa(token),
					"Content-Type": "application/json"
				}
			});
		},
	}
};
